const ScrollDirection = {
    UP: 'up',
    DOWN: 'down',
};

export default ScrollDirection;